import {ClientDetailsResponse} from 'src/app/account/my-account/model/agentDetailsResponse.model';
import {AccountType} from '../../enums/AccountType.enum';
import {UnitDepositAccountStatus} from '../../enums/UnitDepositAccountStatus.enum';
import {SignatureListReqRes} from '../SignatureListReqRes.model';
import {UnitStatementReqRes} from './UnitStatementReqRes.model';
import {UnitAchLimits} from '../unit-bank-account/UnitAchLimits.model';
import {UnitBusinessApplicationReqRes} from '../unit-bank-account/UnitBusinessApplicationReqRes.model';
import {CurrencyModel} from '../CurrencyModel';
import UnitAccountProvider from '../../enums/UnitAccountProvider.enum';
import {UnitAccountLimits} from '../unit-bank-account/UnitAccountLimits.model';

export class UnitBankAccountReqRes {
  /** The ID in our database */
  public id: number;

  /**  The Resource ID from Unit */
  public unitResourceId: string;

  /**  Name of the account holder. */
  public name: string;

  /**  The type of the bank account */
  public accountType: AccountType;

  /**  Routing number of account. */
  public routingNumber: string;

  /**  Account number, together with the routingNumber forms the identifier of the account on the ACH network. */
  public accountNumber: string;

  /**  Currency of the account. */
  public currency: string;

  /**  The balance amount (in cents). */
  public balance: number;

  /**  The hold amount (in cents). */
  public hold: number;

  /**  The available balance for spending (in cents). */
  public available: number;

  /** The pending balance of the account (pending ACH debit) in cents */
  public pendingBalance: number;

  public status: UnitDepositAccountStatus;

  /**  Optional. The reason the account was closed. either ByCustomer or Fraud. */
  public closeReason: string;

  // public idempotencyKey: string;

  /**  Account nickname */
  public accountNickname: string;

  /**  The associated unit application ID */
  public unitApplicationId: number;

  /** The associated unit application */
  public unitApplication: UnitBusinessApplicationReqRes;

  public signatureList: SignatureListReqRes;

  public createdByUserId: number;

  public createdByClientDetails: ClientDetailsResponse;

  public statements: UnitStatementReqRes[];

  public transactionFee: number;

  public accountLimits: UnitAccountLimits;

  public isDistributionEnabled: boolean;

  public hasOngoingDistributions: boolean;

  public preferredCurrency: CurrencyModel;

  public isUnitBankAccount: boolean;

  public maxNumberOfVirtualCards: number;

  public provider: UnitAccountProvider;

  public depositProduct: string;
}
